import { api } from 'shared/api';
import { SkillViewModel } from 'shared/types';

export interface FetchSkillsResponse {
    items: SkillViewModel[];
    totalItems: number;
    matchedItems: number;
    highlights: string[];
}

export const searchSkills = async (
    searchString: string,
    pageNum = 1,
    pageSize = 20,
    signal?: AbortSignal
) => {
    const params = new URLSearchParams({
        searchString,
        pageNum: pageNum.toString(),
        pageSize: pageSize.toString()
    });
    
    return await api.get<FetchSkillsResponse>(
        `/Skills/Search?${ params.toString() }`,
        undefined,
        { signal }
    );
};
